import { useEffect, useCallback } from "react";

export function useZenMode(
  zenModeEnabled: boolean,
  introCompleted: boolean,
  setUiVisible: (visible: boolean) => void
) {
  // Zen mode effect - simultaneous fade transitions
  useEffect(() => {
    if (zenModeEnabled && introCompleted) {
      // Only apply zen mode after intro is complete
      // Fade out UI - normal beats will fade out and centered beats will fade in simultaneously
      setUiVisible(false);
    } else if (!zenModeEnabled && introCompleted) {
      // Restore normal state only after intro is complete
      // Fade in UI - centered beats will fade out and normal beats will fade in simultaneously
      setUiVisible(true);
    }
  }, [zenModeEnabled, introCompleted, setUiVisible]);

  // Handle any interaction to exit zen mode
  const handleInteraction = useCallback(
    (event: Event) => {
      // Don't exit zen mode if the interaction is with a toggle switch, button, or beat dot
      const target = event.target as HTMLElement;
      if (
        target &&
        (target.closest(".toggle-switch") || 
         target.closest("button") ||
         target.tagName === "circle") // Beat dots are SVG circle elements
      ) {
        return;
      }

      if (zenModeEnabled) {
        return true; // Signal to exit zen mode
      }
      return false;
    },
    [zenModeEnabled]
  );

  return { handleInteraction };
}
